import { createSelector } from 'reselect'
import _ from 'lodash';

export const translationsList = (state) => state.translations.translations;
export const translationsLoading = (state) => state.translations.translationsLoading;




// WEBPACK FOOTER //
// ./src/storeState/translations/selectors.js